export const DATE_FORMAT_DATETIME = 'dd-MM-yyyy, HH:mm';
export const DATE_FORMAT_DATE = 'dd-MM-yyyy';
export const DATE_FORMAT_PICKER = 'DD-MM-YYYY';

export const MOBILE_HEADER_HEIGHT = 85;
export const MAX_FORMULA_INT = 9223372036854775807;

export const MOTION_TRANSITION = { type: 'tween', duration: 0.2 };

export const isDev = process.env.NODE_ENV === 'development';

const getEnvironment = (): 'development' | 'test' | 'staging' | 'production' => {
  if (isDev) {
    return 'development';
  }

  const url = window.location.origin.toLowerCase();

  if (url.includes('test.cydea')) {
    return 'test';
  }

  if (url.includes('staging.cydea')) {
    return 'staging';
  }

  return 'production';
};

export const env = getEnvironment();
